export enum Layouts {
  Calendar = 1,
  Table,
  List
}

export const Courses = ['JS/Frontend 2020-Q3', 'React 2020-Q3', 'Node 2020-Q3'];
